// extracted by mini-css-extract-plugin
export default {"row":"Admin_row__6imt2","answer":"Admin_answer__5z7I5","button":"Admin_button__WMtRw","textbox":"Admin_textbox__5WgyJ"};